import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notar la confusión",
    opening: localizedGenderNode(
      [
      "Hoy no intento definir quién soy.",
      "Solo me siento conmigo dentro de la pregunta.",
      "Eso es suficiente por ahora."
    ],
      [
      "Hoy no intento definir quién soy.",
      "Solo me siento conmigo dentro de la pregunta.",
      "Eso es suficiente por ahora."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo me siento menos yo?",
      "¿Qué pasó antes de empezar a sentirme así?",
      "¿Qué parte de mí pide reconocimiento ahora?"
    ],
      [
      "¿Cuándo me siento menos yo?",
      "¿Qué pasó antes de empezar a sentirme así?",
      "¿Qué parte de mí pide reconocimiento ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Incluso la confusión es una señal de que todavía me busco."
    ],
      [
      "Incluso la confusión es una señal de que todavía me busco."
    ]
    ),
    action: localizedGenderNode(
      "una frase para mí — \"Estoy aquí\".",
      "una frase para mí — \"Estoy aquí\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Qué cambió en mí",
    opening: localizedGenderNode(
      [
      "Hoy noto los cambios.",
      "Sin intentar arreglarlos.",
      "Solo verlos."
    ],
      [
      "Hoy noto los cambios.",
      "Sin intentar arreglarlos.",
      "Solo verlos."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento mi cuerpo en la silla."
    ],
      [
      "Respiro despacio.",
      "Siento mi cuerpo en la silla."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué en mí cambió en este período?",
      "¿Qué se mantuvo igual a pesar de todo?",
      "¿Qué me asusta de este cambio?"
    ],
      [
      "¿Qué en mí cambió en este período?",
      "¿Qué se mantuvo igual a pesar de todo?",
      "¿Qué me asusta de este cambio?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El cambio no me borra, solo me confunde."
    ],
      [
      "El cambio no me borra, solo me confunde."
    ]
    ),
    action: localizedGenderNode(
      "una respiración con la palabra \"permitido\".",
      "una respiración con la palabra \"permitido\"."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Momentos en que sí soy yo",
    opening: localizedGenderNode(
      [
      "Hoy busco momentos de mí.",
      "Aunque sean pequeños.",
      "Eso basta."
    ],
      [
      "Hoy busco momentos de mí.",
      "Aunque sean pequeños.",
      "Eso basta."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Noto mi respiración."
    ],
      [
      "Me detengo un momento.",
      "Noto mi respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo fue la última vez que me sentí yo?",
      "¿Qué había allí que me gustó?",
      "¿Cómo se siente en mi cuerpo cuando soy yo?"
    ],
      [
      "¿Cuándo fue la última vez que me sentí yo?",
      "¿Qué había allí que me gustó?",
      "¿Cómo se siente en mi cuerpo cuando soy yo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Hay puntos de luz en mí, aunque sean pocos."
    ],
      [
      "Hay puntos de luz en mí, aunque sean pocos."
    ]
    ),
    action: localizedGenderNode(
      "recordar un momento así.",
      "recordar un momento así."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Roles que se cayeron",
    opening: localizedGenderNode(
      [
      "Hoy veo los roles que ya no sostienen.",
      "Sin culpa.",
      "Solo verdad."
    ],
      [
      "Hoy veo los roles que ya no sostienen.",
      "Sin culpa.",
      "Solo verdad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pongo una mano en el pecho.",
      "Una respiración."
    ],
      [
      "Pongo una mano en el pecho.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué rol en mí se cayó últimamente?",
      "¿Qué me daba que se sentía seguro?",
      "¿Qué temo ser sin eso?"
    ],
      [
      "¿Qué rol en mí se cayó últimamente?",
      "¿Qué me daba que se sentía seguro?",
      "¿Qué temo ser sin eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Aun sin un rol, sigo siendo yo."
    ],
      [
      "Aun sin un rol, sigo siendo yo."
    ]
    ),
    action: localizedGenderNode(
      "una frase de consuelo para mí.",
      "una frase de consuelo para mí."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Qué intento ser",
    opening: localizedGenderNode(
      [
      "Hoy noto lo que intento sostener.",
      "Sin juzgar.",
      "Solo ver."
    ],
      [
      "Hoy noto lo que intento sostener.",
      "Sin juzgar.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia el abdomen.",
      "Estoy aquí."
    ],
      [
      "Respiro hacia el abdomen.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué intento ser para sentirme seguro/a?",
      "¿A quién intento encajarme?",
      "¿Qué me cuesta esto?"
    ],
      [
      "¿Qué intento ser para sentirme seguro/a?",
      "¿A quién intento encajarme?",
      "¿Qué me cuesta esto?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Sostener un rol cansa."
    ],
      [
      "Sostener un rol cansa."
    ]
    ),
    action: localizedGenderNode(
      "soltar el esfuerzo por un momento.",
      "soltar el esfuerzo por un momento."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Voces de fuera",
    opening: localizedGenderNode(
      [
      "Hoy identifico lo que viene de fuera.",
      "Y lo que queda dentro.",
      "Sin pelea."
    ],
      [
      "Hoy identifico lo que viene de fuera.",
      "Y lo que queda dentro.",
      "Sin pelea."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Escucho el silencio."
    ],
      [
      "Me detengo un momento.",
      "Escucho el silencio."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué voz externa me domina más?",
      "¿Qué me dice que \"debo\" ser?",
      "¿Qué dice mi voz interna a la vez?"
    ],
      [
      "¿Qué voz externa me domina más?",
      "¿Qué me dice que \"debo\" ser?",
      "¿Qué dice mi voz interna a la vez?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Hay más de una voz en mí, y puedo elegir a cuál escuchar."
    ],
      [
      "Hay más de una voz en mí, y puedo elegir a cuál escuchar."
    ]
    ),
    action: localizedGenderNode(
      "dar espacio a una voz tranquila.",
      "dar espacio a una voz tranquila."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Qué extraño de mí",
    opening: localizedGenderNode(
      [
      "Hoy encuentro una nostalgia interna.",
      "Sin arreglar.",
      "Solo sentir."
    ],
      [
      "Hoy encuentro una nostalgia interna.",
      "Sin arreglar.",
      "Solo sentir."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pongo una mano en el abdomen.",
      "Una respiración."
    ],
      [
      "Pongo una mano en el abdomen.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué extraño de mí?",
      "¿Cuándo tuve más de eso?",
      "¿Qué le daría un pequeño lugar hoy?"
    ],
      [
      "¿Qué extraño de mí?",
      "¿Cuándo tuve más de eso?",
      "¿Qué le daría un pequeño lugar hoy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La nostalgia también es un hilo de conexión."
    ],
      [
      "La nostalgia también es un hilo de conexión."
    ]
    ),
    action: localizedGenderNode(
      "recordarme una cosa que me gusta de mí.",
      "recordarme una cosa que me gusta de mí."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Valores silenciosos",
    opening: localizedGenderNode(
      [
      "Hoy miro lo que de verdad me importa.",
      "No en voz alta.",
      "En silencio."
    ],
      [
      "Hoy miro lo que de verdad me importa.",
      "No en voz alta.",
      "En silencio."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Me doy un momento."
    ],
      [
      "Respiro despacio.",
      "Me doy un momento."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué valor se queda conmigo?",
      "¿Cómo se ve en un día simple?",
      "¿Qué puedo hacer para honrarlo hoy?"
    ],
      [
      "¿Qué valor se queda conmigo?",
      "¿Cómo se ve en un día simple?",
      "¿Qué puedo hacer para honrarlo hoy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un valor puede ser un hilo de mí."
    ],
      [
      "Un valor puede ser un hilo de mí."
    ]
    ),
    action: localizedGenderNode(
      "una palabra que exprese ese valor.",
      "una palabra que exprese ese valor."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Un límite pequeño",
    opening: localizedGenderNode(
      [
      "Hoy reviso un límite que me protege.",
      "No para alejarme.",
      "Para quedarme."
    ],
      [
      "Hoy reviso un límite que me protege.",
      "No para alejarme.",
      "Para quedarme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Siento mis pies en el suelo."
    ],
      [
      "Me detengo un momento.",
      "Siento mis pies en el suelo."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde tiendo a abandonarme?",
      "¿Qué límite pequeño me ayudaría a quedarme en mí?",
      "¿Cómo puedo decírmelo primero?"
    ],
      [
      "¿Dónde tiendo a abandonarme?",
      "¿Qué límite pequeño me ayudaría a quedarme en mí?",
      "¿Cómo puedo decírmelo primero?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un límite pequeño es protección, no pelea."
    ],
      [
      "Un límite pequeño es protección, no pelea."
    ]
    ),
    action: localizedGenderNode(
      "una frase de límite para mí.",
      "una frase de límite para mí."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una elección pequeña",
    opening: localizedGenderNode(
      [
      "Hoy elijo algo pequeño que me acerca a mí.",
      "Sin drama.",
      "Un paso pequeño."
    ],
      [
      "Hoy elijo algo pequeño que me acerca a mí.",
      "Sin drama.",
      "Un paso pequeño."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro y noto.",
      "Estoy aquí."
    ],
      [
      "Respiro y noto.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué elección pequeña se sentiría verdadera para mí?",
      "¿Qué me detiene de hacerla?",
      "¿Qué pasa si hago solo el 10%?"
    ],
      [
      "¿Qué elección pequeña se sentiría verdadera para mí?",
      "¿Qué me detiene de hacerla?",
      "¿Qué pasa si hago solo el 10%?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una elección pequeña puede recordarme quién soy."
    ],
      [
      "Una elección pequeña puede recordarme quién soy."
    ]
    ),
    action: localizedGenderNode(
      "un paso del 10%.",
      "un paso del 10%."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Un nombre nuevo para mí",
    opening: localizedGenderNode(
      [
      "Hoy me doy una descripción suave.",
      "No una etiqueta.",
      "Solo palabras amables."
    ],
      [
      "Hoy me doy una descripción suave.",
      "No una etiqueta.",
      "Solo palabras amables."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Siento el aire entrar y salir."
    ],
      [
      "Me detengo un momento.",
      "Siento el aire entrar y salir."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué palabra buena me describe hoy?",
      "¿Qué hago que muestra esa palabra?",
      "¿Cómo se siente oírla sobre mí?"
    ],
      [
      "¿Qué palabra buena me describe hoy?",
      "¿Qué hago que muestra esa palabra?",
      "¿Cómo se siente oírla sobre mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una palabra buena puede ser un ancla."
    ],
      [
      "Una palabra buena puede ser un ancla."
    ]
    ),
    action: localizedGenderNode(
      "decir esa palabra en mi corazón.",
      "decir esa palabra en mi corazón."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Hilos que sostienen",
    opening: localizedGenderNode(
      [
      "Hoy noto hilos que me sostienen.",
      "Aunque sean finos.",
      "Existen."
    ],
      [
      "Hoy noto hilos que me sostienen.",
      "Aunque sean finos.",
      "Existen."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento mi cuerpo aflojar un poco."
    ],
      [
      "Respiro despacio.",
      "Siento mi cuerpo aflojar un poco."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me sostiene cuando me siento confundido/a?",
      "¿Quién o qué me recuerda quién soy?",
      "¿Qué puedo sostener hoy?"
    ],
      [
      "¿Qué me sostiene cuando me siento confundido/a?",
      "¿Quién o qué me recuerda quién soy?",
      "¿Qué puedo sostener hoy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un hilo delgado basta para no perderlo todo."
    ],
      [
      "Un hilo delgado basta para no perderlo todo."
    ]
    ),
    action: localizedGenderNode(
      "sostener algo pequeño que me calme.",
      "sostener algo pequeño que me calme."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Estar en proceso",
    opening: localizedGenderNode(
      [
      "Hoy me permito estar en medio.",
      "No es final.",
      "No es un error."
    ],
      [
      "Hoy me permito estar en medio.",
      "No es final.",
      "No es un error."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde me exijo una respuesta ahora?",
      "¿Qué pasa si me doy tiempo?",
      "¿Cómo se ve un día sin perseguir una respuesta?"
    ],
      [
      "¿Dónde me exijo una respuesta ahora?",
      "¿Qué pasa si me doy tiempo?",
      "¿Cómo se ve un día sin perseguir una respuesta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Estar en medio es un lugar real."
    ],
      [
      "Estar en medio es un lugar real."
    ]
    ),
    action: localizedGenderNode(
      "decirme \"Está bien no saber\".",
      "decirme \"Está bien no saber\"."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy elijo una frase que me trae de vuelta.",
      "Cuando me pierdo.",
      "Una frase pequeña."
    ],
      [
      "Hoy elijo una frase que me trae de vuelta.",
      "Cuando me pierdo.",
      "Una frase pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre mí en este recorrido?",
      "¿Cuál es la primera señal de que me alejo de mí?",
      "¿Qué frase corta me devuelve?"
    ],
      [
      "¿Qué aprendí sobre mí en este recorrido?",
      "¿Cuál es la primera señal de que me alejo de mí?",
      "¿Qué frase corta me devuelve?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo perderme y volver con una sola respiración."
    ],
      [
      "Puedo perderme y volver con una sola respiración."
    ]
    ),
    action: localizedGenderNode(
      "decir la nueva frase una vez.",
      "decir la nueva frase una vez."
    ),
  },
].map(buildNormalizedDay);

export const lossOfSenseOfIdentityWhoAmIEvenTodayBlueprintEs = buildNormalizedPilotBlueprint({
  id: "loss_of_sense_of_identity_who_am_i_even_today_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "loss_of_sense_of_identity_who_am_i_even_today",
  category: "depression_emptiness_meaning",
  journeyName: {
    he: "אובדן תחושת זהות (מי אני בכלל היום)",
    en: "Loss of sense of identity (Who am I even today)",
    es: "Pérdida del sentido de identidad (¿Quién soy yo hoy?)",
  },
  days,
});

export default lossOfSenseOfIdentityWhoAmIEvenTodayBlueprintEs;
